import { Box, Flex, Heading } from '@chakra-ui/react'
import React, { FC } from 'react'
import { use100vh } from 'react-div-100vh'

import { Nav } from './Nav'

type Props = {
  title?: string
  dashboard?: boolean
}

const DashboardLayout: FC<Props> = ({ title, children, dashboard }) => {
  const height = use100vh()

  return (
    <Flex
      pos="relative"
      flexDir="column"
      maxW={{ md: '480px' }}
      w="full"
      mx="auto"
      pb="2.4rem"
      px="2.4rem"
      h={height || undefined}>
      {title && (
        <Heading pt="3.2rem" mb="2rem" fontWeight="500" fontSize="1.6rem" color="black">
          {title}
        </Heading>
      )}
      <Box
        pt={title ? 0 : '3.2rem'}
        className="containerScroll"
        mb="6rem"
        overflow="scroll"
        flex="1">
        {children}
      </Box>

      {title && <Nav />}
      {dashboard && <Nav />}
    </Flex>
  )
}

export { DashboardLayout }
